import type { Schema } from '@wix/wix-data-schema-types'
import { FieldType } from '@wix/wix-data-schema-types'
import { MAIN_SLUG_FIELD_KEY } from './constants'

export const hasMainSlugField = (schema: Schema) => {
  const field = schema.fields[MAIN_SLUG_FIELD_KEY]

  return !!field && field.type === FieldType.slug
}
